import CustomHelmet from '../CustomHelmet';
import { Button, Box, Typography, Grid, FormControl } from '@mui/material';
import { Link } from 'react-router-dom';
import { BASE_TITLE } from '../Common';
import aiServices from '../ListGroups/AiServices';
import AiServiceSection from './AiServiceSection';
import { categoryTabLinkSx, categoryTabTitleSx, categoryTabDescSx } from '../designTokens';
import { aiServicesSeo } from '../seoMeta';

const Index = () => {
    return (
        <>
            <CustomHelmet
                title={BASE_TITLE + 'AI 應用系統服務'}
                description={aiServicesSeo.description}
                keywords={aiServicesSeo.keywords}
            />
            <FormControl component="article" fullWidth>
                {/* Quick nav */}
                <Grid container spacing={2} sx={{ mb: { xs: 4, md: 5 } }}>
                    {aiServices.map((product, index) => (
                        <Grid item xs={12} sm={6} md={3} key={product.id}>
                            <Box component="a" href={`#${product.id}`} sx={categoryTabLinkSx}>
                                <Typography className="category-tab-title" sx={categoryTabTitleSx}>
                                    {index + 1}. {product.tag}
                                </Typography>
                                <Typography variant="body2" className="category-tab-desc" sx={categoryTabDescSx}>
                                    {product.title}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>

                {/* Product sections */}
                {aiServices.map((product, index) => (
                    <AiServiceSection
                        key={product.id}
                        product={product}
                        index={index}
                        reverse={index % 2 === 1}
                    />
                ))}

                {/* CTA */}
                <Box
                    sx={{
                        mt: 2,
                        p: { xs: 3, md: 4 },
                        textAlign: 'center',
                        borderRadius: '12px',
                        backgroundColor: '#F5FCFC',
                        border: '1px solid #DAEDED',
                    }}
                >
                    <Typography variant="h6" sx={{ fontWeight: 700, color: '#03363D', mb: 1 }}>
                        想進一步了解 AI 應用如何導入您的企業？
                    </Typography>
                    <Typography sx={{ color: 'text.secondary', mb: 3, maxWidth: 560, mx: 'auto' }}>
                        歡迎與我們聯繫，由顧問為您說明適用的方案與導入流程。
                    </Typography>
                    <Button
                        component={Link}
                        to="/contactus"
                        state={{ anchor: 'default' }}
                        size="large"
                        variant="contained"
                        color="primary"
                        sx={{ fontSize: '16px', px: 4 }}
                    >
                        洽詢 AI 應用系統服務
                    </Button>
                </Box>
            </FormControl>
        </>
    );
};

export default Index;
